/**
 * Seiten, auf denen für den Consent-Manager Sonderregeln gelten.
 *
 * Auf diesen Seiten erscheint beim Aufruf kein Cookie-Banner, und die unten unter
 * cookieUnblockedProviders eingetragenen Anbieter werden ohne Einwilligung freigeschaltet.
 *
 * Gepflegt werden Pfade ("/de/roadshow-checkliste") oder vollständige URLs
 * ("https://www.eila.de/de/roadshow-checkliste"). Query-String, Anker,
 * Groß-/Kleinschreibung und ein abschließender "/" spielen beim Abgleich keine Rolle.
 *
 * Nach einer Änderung muss das Bundle neu gebaut werden:
 *   cd frontend/eila && npx gulp public
 *
 * @type {string[]}
 */
export const cookieExceptionPages = [
    '/de/roadshow-checkliste',
    '/de/roadshow-innovation-days',
    '/de/roadshow-beratung',
    '/de/roadshow-testen',
];

/**
 * Anbieter, die auf den oben genannten Seiten ohne Einwilligung geladen werden.
 *
 * Achtung: Diese Anbieter laden dort unabhängig davon, ob der Besucher zugestimmt hat.
 * Auf allen übrigen Seiten bleibt die normale Einwilligung erforderlich. Einträge nur
 * nach Abstimmung mit dem Kunden ergänzen — leere Liste bedeutet: nur das Banner
 * ausblenden, sonst nichts freigeben.
 *
 * - provider:    ID des Anbieters aus der Cookie-Konfiguration (GLOBALS.dcCookie.providers),
 *                z. B. "hubspot".
 * - keepBlocked: CSS-Selektoren für Skripte desselben Anbieters, die trotzdem
 *                blockiert bleiben sollen. Optional.
 *
 * Unterstützt werden die Skripte eines Anbieters und seine Externe-Medien-Container.
 *
 * @type {{provider: string, keepBlocked?: string[]}[]}
 */
export const cookieUnblockedProviders = [
    {
        provider: 'hubspot',
        // Seitenweites HubSpot-Tracking. Für die Formulare nicht nötig, bleibt deshalb blockiert:
        // der Formular-Embed lädt sein Skript (js.hsforms.net) selbst nach.
        keepBlocked: ['#hs-script-loader'],
    },
];
